import React, { useCallback, useEffect, useState } from 'react'
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";

import image1 from '../assest/banner/fasal_banner1.png'
import image2 from '../assest/banner/fasal_banner2.png'
import image3 from '../assest/banner/fasal_banner3.png'
import image4 from '../assest/banner/fasal_banner4.png'
import image5 from '../assest/banner/fasal_banner5.png'

const banners = [
    image1,
    image2,
    image3,
    image4,
    image5
]

const BannerProduct = () => {
    const [currentImage, setCurrentImage] = useState(0)
    const [touchStart, setTouchStart] = useState(null)
    const [touchEnd, setTouchEnd] = useState(null)

    const minSwipeDistance = 50

    const nextImage = useCallback(() => {
        if (banners.length - 1 > currentImage) {
            setCurrentImage(prev => prev + 1)
        } else {
            setCurrentImage(0)
        }
    }, [currentImage])

    const preveImage = () => {
        if (currentImage !== 0) {
            setCurrentImage(prev => prev - 1)
        } else {
            setCurrentImage(banners.length - 1)
        }
    }

    const onTouchStart = (e) => {
        setTouchEnd(null)
        setTouchStart(e.targetTouches[0].clientX)
    }

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX)
    }

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return
        const distance = touchStart - touchEnd
        const isLeftSwipe = distance > minSwipeDistance
        const isRightSwipe = distance < -minSwipeDistance
        if (isLeftSwipe) {
            nextImage()
        } else if (isRightSwipe) {
            preveImage()
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            nextImage()
        }, 6000)

        return () => clearInterval(interval)
    }, [nextImage])

    return (
        <div className='w-full'>
            <div
                className='h-48 sm:h-64 md:h-[400px] lg:h-[460px] w-full bg-slate-100 relative overflow-hidden group'
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
            >
                {/* Navigation Arrows */}
                <div className='absolute z-20 h-full w-full md:flex items-center hidden opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none'>
                    <div className='flex justify-between w-full px-6 pointer-events-auto'>
                        <button onClick={preveImage} className='bg-white/90 backdrop-blur-md shadow-xl rounded-full p-3 hover:bg-[#00b259] hover:text-white transition-all text-[#143d2c]' aria-label="Previous Banner">
                            <FaAngleLeft size={20} />
                        </button>
                        <button onClick={nextImage} className='bg-white/90 backdrop-blur-md shadow-xl rounded-full p-3 hover:bg-[#00b259] hover:text-white transition-all text-[#143d2c]' aria-label="Next Banner">
                            <FaAngleRight size={20} />
                        </button>
                    </div>
                </div>

                {/* Dots Indicators */}
                <div className='absolute bottom-3 left-1/2 -translate-x-1/2 z-20 flex gap-2'>
                    {banners.map((_, index) => (
                        <button
                            key={"dot" + index}
                            onClick={() => setCurrentImage(index)}
                            className={`h-1.5 transition-all duration-500 rounded-full cursor-pointer ${currentImage === index ? 'w-8 bg-[#00b259]' : 'w-2 bg-white/50 hover:bg-white'}`}
                            aria-label={`Go to slide ${index + 1}`}
                        ></button>
                    ))}
                </div>

                {/* Main Slider */}
                <div className='flex h-full w-full overflow-hidden'>
                    {banners.map((imgUrl, index) => {
                        return (
                            <div
                                className='w-full h-full min-w-full min-h-full relative transition-all duration-700 ease-in-out'
                                key={"banner" + index}
                                style={{ transform: `translateX(-${currentImage * 100}%)` }}
                            >
                                <img src={imgUrl} className='w-full h-full object-cover object-center' alt={`Banner ${index + 1}`} />

                                {/* Overlay Gradient */}
                                <div className='absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent'></div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default BannerProduct